import React, { useEffect, useState } from 'react'
import { getAffiliateProgramDetailsApi } from '../../service/api/paymentGateway/getAffiliateProgramDetails'
import { useDispatch } from 'react-redux'
import SkeletonDivElement from '../../component/skeletonTableRow/skeletonDivElement';
import PrimaryButton from '../../jsx/components/button/primaryButton';
import { Modal } from 'react-bootstrap';
import InputField from '../../jsx/components/fields/inputField';
import updateAffiliateProgramDetailsApi from '../../service/api/paymentGateway/updateAffiliateProgramDetails';
import ResponceToaster from '../../jsx/components/responceToaster/responceToaster';

const AffiliateProgram = () => {
    const dispatch = useDispatch();
    const [affiliateLoading, setAffiliateLoading] = useState(false);
    const [updateAffiliateLoading, setUpdateAffiliateLoading] = useState(false);
    const [affiliateDetails, setAffiliateDetails] = useState({});

    const [commissionDays, setCommissionDays] = useState(``);
    const [commissionServices, setCommissionServices] = useState(``);
    const [commissionPercentage, setCommissionPercentage] = useState(``);

    const [isCommissionDaysError, setIsCommissionDaysError] = useState(false);
    const [isCommissionServicesError, setIsCommissionServicesError] = useState(false);
    const [isCommissionPercentageError, setIsCommissionPercentageError] = useState(false);

    const [responceMsg, setResponceMsg] = useState("");
    const [toasterType, setToasterType] = useState('');
    const [handleToaster, setHandleToaster] = useState(false);

    const handleCommissionDays = (e) => {
        setIsCommissionDaysError(false)
        setCommissionDays(e.target.value.replace(/\D/g, ''));
    }

    const handleCommissionDaysBlurCheck = () => {
        if (isNaN(commissionDays) || commissionDays === '' || (commissionDays > 100)) {
            setIsCommissionDaysError(true);
        }
    }

    const handleCommissionServices = (e) => {
        setIsCommissionServicesError(false)
        setCommissionServices(e.target.value.replace(/\D/g, ''));
    }

    const handleCommissionServicesBlurCheck = () => {
        if (isNaN(commissionDays) || commissionDays === '') {
            setIsCommissionServicesError(true);
        }
    }

    const handleCommissionPercent = (e) => {
        setIsCommissionPercentageError(false)
        let value = e.target.value.replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1');
        if (parseFloat(value) >= 100) {
            value = 99.99;
        }
        setCommissionPercentage(value);
    }

    const handleCommissionPercentBlurCheck = () => {
        if (isNaN(commissionDays) || commissionDays === '') {
            setIsCommissionPercentageError(true);
            alert("Please enter valid percentage");
        }
    }

    const getAffiliateProgramDetailFn = () => {
        setAffiliateLoading(true)
        let data = {}
        dispatch(
            getAffiliateProgramDetailsApi(data,
                (res) => {
                    setAffiliateLoading(false);
                    // console.log(res.data.data);

                    setAffiliateDetails(res.data.data)

                    setCommissionDays(res.data.data.commission_available_till_no_of_days_from_creation_int)
                    setCommissionServices(res.data.data.commission_available_for_no_of_request_int)
                    setCommissionPercentage(res.data.data.commission_transferred_percentage_to_pro_float)
                },
                (res) => {
                    setAffiliateLoading(false)
                    console.log(res)
                })
        )
    }

    useEffect(() => {
        getAffiliateProgramDetailFn();
    }, [])

    const [updateAffiliateModalTrigger, setUpdateAffiliateModalTrigger] = useState(false);
    const handleUpdateAffiliateModal = () => {
        setUpdateAffiliateModalTrigger(!updateAffiliateModalTrigger)
        handleClearAffiliateStates();
    }

    const handleUpdateAffiliateProgram = (e) => {
        e.preventDefault();

        if (isNaN(commissionDays) || commissionDays === '') {
            setIsCommissionDaysError(true);
        }

        if (isNaN(commissionServices) || commissionServices === '') {
            setIsCommissionServicesError(true);
        }

        if (isNaN(commissionPercentage) || commissionPercentage === '' || (commissionPercentage > 100)) {
            setIsCommissionPercentageError(true);
        }

        if (isNaN(commissionDays) || commissionDays === '' ||
            isNaN(commissionServices) || commissionServices === '' ||
            isNaN(commissionPercentage) || commissionPercentage === '' || (commissionPercentage > 100)
        ) {
            return;
        }

        if (!isCommissionDaysError || !isCommissionServicesError || !isCommissionPercentageError) {

            setUpdateAffiliateLoading(true)
            // console.log(commissionDays, commissionServices, commissionPercentage);
            let details = new FormData();
            details.append("commission_available_till_no_of_days_from_creation_int", parseInt(commissionDays));
            details.append("commission_transferred_percentage_to_pro_float", parseFloat(commissionPercentage));
            details.append("commission_available_for_no_of_request_int", commissionServices);

            dispatch(
                updateAffiliateProgramDetailsApi(
                    details,
                    (res) => {
                        // console.log(res)
                        setUpdateAffiliateLoading(false)
                        setResponceMsg(res.data.message)
                        setToasterType("success")

                        handleUpdateAffiliateModal();

                        getAffiliateProgramDetailFn();

                        setHandleToaster(true);
                        setTimeout(() => {
                            setHandleToaster(false);
                        }, 11000);
                    },
                    (res) => {
                        // console.log(res)
                        setUpdateAffiliateLoading(false)
                        setResponceMsg(res.data.message)
                        setToasterType("error");

                        setHandleToaster(true);
                        setTimeout(() => {
                            setHandleToaster(false);
                        }, 11000);
                    }
                )
            )
        }
    }

    const handleClearAffiliateStates = () => {
        setIsCommissionDaysError(false);
        setIsCommissionServicesError(false);
        setIsCommissionPercentageError(false);
    }

    return (
        <>
            <div className='row mx-3 mb-5'>
                <div className='col-12 px-0'>
                    <div className="row mx-0 p-3">
                        <div className="col-6 px-0 ps-2 d-flex align-item-center justify-content-start">
                            <span className="fs-4 fw-bold text-black">{"Affiliate Program"}</span>
                        </div>

                        <div className='row mx-0 my-5 mx-3'>
                            <div className='col-12 px-0 fs-4'>

                                {affiliateLoading ?
                                    <SkeletonDivElement
                                        height={"50px"}
                                        marginBottom={"10px"}
                                        rows={3}
                                    />
                                    :
                                    <>
                                        <div className='row my-3'>
                                            <div className='col-md-4 col-sm-6 col-6 pe-2'>
                                                <span className='font-w600 text-black'>{`Number of days commission is aplicable`}</span>
                                            </div>

                                            <div className='col-md-8 col-sm-6 col-6 ps-2'>
                                                <span>{`${affiliateDetails?.commission_available_till_no_of_days_from_creation_int} days`}</span>
                                            </div>
                                        </div>

                                        {/* <div className='row my-2'>
                                            <div className='col-12'>
                                                <span className='ms-4 font-w600'>{`OR`}</span>
                                            </div>
                                        </div> */}

                                        <div className='row my-3'>
                                            <div className='col-md-4 col-sm-6 col-6 pe-2'>
                                                <span className='font-w600 text-black'>{`Number of services commission is aplicable`}</span>
                                            </div>

                                            <div className='col-md-8 col-sm-6 col-6 ps-2'>
                                                <span>{`${affiliateDetails?.commission_available_for_no_of_request_int} services`}</span>
                                            </div>
                                        </div>

                                        <div className='row my-3'>
                                            <div className='col-md-4 col-sm-6 col-6 pe-2'>
                                                <span className='font-w600 text-black'>{`Commission percentage given`}</span>
                                            </div>

                                            <div className='col-md-8 col-sm-6 col-6 ps-2'>
                                                <span>{`${affiliateDetails?.commission_transferred_percentage_to_pro_float?.toFixed(2)}%`}</span>
                                            </div>
                                        </div>
                                    </>}

                                <div className='row mx-0 mt-5'>
                                    <div className='col-12 px-0 d-flex justify-content-center align-items-center'>
                                        <PrimaryButton
                                            onClick={() => {
                                                handleUpdateAffiliateModal();
                                            }}
                                            buttonName={"UPDATE AFFILIATE PROGRAM"}
                                            type="submit"
                                            loadingMessage="UPDATING..."
                                            isLoading={false}
                                            style={{
                                                width: '',
                                                background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                                                border: '2px solid rgba(255, 154, 32, 1)',
                                                boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                            }}
                                        />
                                    </div>
                                </div>

                            </div>
                        </div>

                    </div>
                </div>
            </div>


            {/* <!-- Modal For the expertise edit/delete/add --> */}
            <>
                <Modal className="fade" show={updateAffiliateModalTrigger}
                    // onHide={handleClose} 
                    centered
                >
                    <Modal.Body>

                        <div className='row mx-0'>
                            <div className='col-12 px-0'>
                                <form onSubmit={(e) => handleUpdateAffiliateProgram(e)} >
                                    <div className='mx-0 row text-black mb-4'>
                                        <div className='col-11 font-w600 fs-3 px-0 text-center'>
                                            <span>
                                                {`Update affiliate details`}
                                            </span>
                                        </div>
                                        <div className='col-1 d-flex fs-4 justify-content-end px-0'>
                                            <span onClick={() => handleUpdateAffiliateModal()} className='cursor-pointer'>
                                                <i className="bi bi-x-lg"></i>
                                            </span>
                                        </div>
                                    </div>


                                    <>


                                        <div className='row mx-0'>

                                            <div className='col-12 px-0 '>
                                                <InputField
                                                    labelName={"Number of days commission is aplicable"}
                                                    placeholderName={"Number of days commission is aplicable"}
                                                    onChange={handleCommissionDays}
                                                    onBlur={handleCommissionDaysBlurCheck}
                                                    errorOccured={isCommissionDaysError}
                                                    errorMeesage={`Please enter valid number of days`}
                                                    value={`${commissionDays}`}
                                                    maxLength={3}
                                                    isRequired={true}
                                                />
                                            </div>

                                            <div className='col-12 px-0 '>
                                                <InputField
                                                    labelName={"Number of services commission is aplicable"}
                                                    placeholderName={"Number of services commission is aplicable"}
                                                    onChange={handleCommissionServices}
                                                    onBlur={handleCommissionServicesBlurCheck}
                                                    errorOccured={isCommissionServicesError}
                                                    errorMeesage={`Please enter valid number of services`}
                                                    value={`${commissionServices}`}
                                                    // maxLength={3}
                                                    isRequired={true}
                                                />
                                            </div>

                                            <div className='col-12 px-0 '>
                                                <InputField
                                                    labelName={"Commission percentage given"}
                                                    placeholderName={"Commission percentage given"}
                                                    onChange={handleCommissionPercent}
                                                    onBlur={handleCommissionPercentBlurCheck}
                                                    errorOccured={isCommissionPercentageError}
                                                    errorMeesage={`Please enter valid percentage commission`}
                                                    value={`${commissionPercentage}`}
                                                    // maxLength={3}
                                                    isRequired={true}
                                                />
                                            </div>

                                        </div>

                                        <div className='row mx-0 mt-2'>
                                            <div className='col-12 px-0'>
                                                <PrimaryButton
                                                    onClick={(e) => handleUpdateAffiliateProgram(e)}
                                                    buttonName={`UPDATE`}
                                                    type={"submit"}
                                                    loadingMessage={"UPDATING..."}
                                                    isLoading={updateAffiliateLoading}
                                                    style={{
                                                        width: '100%',
                                                        background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                                                        boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                                        border: '1px solid rgba(255, 154, 32, 1)',
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </>
                                </form>
                            </div>
                        </div>
                    </Modal.Body>
                </Modal>
            </>

            {handleToaster && <ResponceToaster toasterType={toasterType} message={responceMsg} />}
        </>
    )
}

export default AffiliateProgram